"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const axios_1 = __importDefault(require("axios"));
const async_1 = __importDefault(require("react-select/async"));
const utils_1 = require("../components/utils");
const api_1 = require("../api");
const Button_1 = __importDefault(require("../forms/Button"));
const quickOrderedFilter_1 = require("../components/quickOrderedFilter");
const react_helmet_1 = __importDefault(require("react-helmet"));
const IsAllowed_1 = __importDefault(require("../Auth/IsAllowed"));
const ImageList_1 = __importDefault(require("../components/ImageList"));
const react_svg_1 = require("react-svg");
const handleError_1 = __importDefault(require("../handleError"));
const Checkbox = ({ children, ...props }) => (react_1.default.createElement("div", { className: "flex items-center" },
    react_1.default.createElement("input", { id: props.id, type: "checkbox", className: "checkboxx" }),
    react_1.default.createElement("label", { htmlFor: props.id, className: "ml-2 block text-sm text-gray-600" }, children)));
const Images = (props) => {
    const [files, setFiles] = (0, react_1.useState)([]);
    const [authors, setAuthors] = (0, react_1.useState)([]);
    const [selectedAuthor, setSelectedAuthor] = (0, react_1.useState)(null);
    const [inputedFiles, setInputedFiles] = (0, react_1.useState)();
    const [selectedFile, setSelectedFile] = (0, react_1.useState)(null);
    const [selectedRecord, setSelectedRecord] = (0, react_1.useState)(null);
    const [submitting, setSubmitting] = (0, react_1.useState)(false);
    const [items, setItems] = (0, react_1.useState)([]);
    const [rotation, setRotation] = (0, react_1.useState)(0);
    const [plantImages, setPlantImages] = (0, react_1.useState)([]);
    const imageListRef = (0, react_1.useRef)();
    const imageApi = new api_1.PicturesApi;
    const authorApi = new api_1.AuthorApi();
    (0, react_1.useEffect)(() => {
        const fetchAuthors = async () => {
            const { items } = await authorApi.index({ active: true });
            setAuthors(items);
        };
        const fetchPlants = async () => {
            const { data } = await axios_1.default.get('/api/searchitems');
            setItems(data.items);
        };
        fetchPlants();
        fetchAuthors();
    }, []);
    (0, react_1.useEffect)(() => {
        setRotation(0);
    }, [selectedFile]);
    const input = (0, react_1.useRef)(null);
    const onChangeHandler = (event) => {
        setInputedFiles(event.target.files);
        const length = event.target.files.length;
        setFiles(files => []);
        setSelectedFile(null);
        for (let i = 0; i < length; i++) {
            (async function (file) {
                let file_reader = new FileReader();
                file_reader.onload = () => {
                    setFiles(files => [...files, { index: i, name: file.name, dataURL: file_reader.result }]);
                };
                file_reader.readAsDataURL(file);
            })(event.target.files[i]);
        }
    };
    const handleSearch = async (query, callback) => {
        const parts = query ? query.toString().toLowerCase().split(' ') : [];
        return callback(items.filter((item) => {
            return (0, quickOrderedFilter_1.quickOrderedFilter)((item['botanisch_slugged'] || '').split("-"), parts);
        }));
    };
    const debouncedSearch = (0, utils_1.debounce)(handleSearch, 300);
    const handleClearFileUpload = (event) => {
        event.preventDefault();
        setFiles([]);
        setSelectedFile(null);
        if (input && input.current) {
            input.current.value = '';
        }
    };
    const loadRecord = async (modelId) => {
        const { images } = await imageApi.index({ modelId });
        setSelectedRecord({ modelId });
        setPlantImages(images);
    };
    const handleSelectChange = async (value) => {
        if (!(0, utils_1.exists)(value)) {
            setSelectedRecord(null);
            return;
        }
        await loadRecord(value.id);
    };
    const handleAssignImage = async () => {
        setSubmitting(true);
        try {
            if (!selectedRecord) {
                throw Error('Es muss eine Pflanze ausgewählt werden.');
            }
            if (!selectedAuthor) {
                throw Error('Es muss ein Autor ausgewählt werden.');
            }
            if (!selectedFile) {
                throw Error('Es muss ein Bild ausgewählt werden.');
            }
            const { modelId } = selectedRecord;
            await imageApi.create({ modelId, authorId: selectedAuthor, file: inputedFiles[selectedFile.index], orientation: rotation });
            // @ts-ignore
            imageListRef.current.reloadImages(modelId);
        }
        catch (error) {
            (0, handleError_1.default)(error);
        }
        setSubmitting(false);
    };
    const handleRotation = (direction) => {
        if (direction === 'left') {
            setRotation(rotation => (rotation - 90) % 360);
            return;
        }
        setRotation(rotation => (rotation + 90) % 360);
    };
    const formatLabel = (option) => {
        return (react_1.default.createElement("div", null,
            "\u00A0#",
            option.id,
            "\u00A0",
            option.botanisch));
    };
    return (react_1.default.createElement(IsAllowed_1.default, { permissions: ['upload_images'] },
        react_1.default.createElement("div", { className: "w-full grid grid-cols-10 gap-6" },
            react_1.default.createElement(react_helmet_1.default, null,
                react_1.default.createElement("title", null, "Images")),
            react_1.default.createElement("div", { className: "col-span-3" },
                react_1.default.createElement("div", { className: "mt-2 sm:mt-0 sm:col-span-2" },
                    react_1.default.createElement("div", { className: "max-w-lg flex flex-col overflow-y-auto p-2 border-2 border-gray-300 border-dashed rounded-md", style: { maxHeight: '88vh' } },
                        react_1.default.createElement("div", { className: "space-y-1 text-center mb-4" },
                            react_1.default.createElement("div", { className: "flex justify-between items-center text-sm text-gray-600" },
                                react_1.default.createElement("div", { className: "flex items-center" },
                                    react_1.default.createElement("svg", { className: "h-12 w-12 mr-4 text-gray-400", stroke: "currentColor", fill: "none", viewBox: "0 0 48 48", "aria-hidden": "true" },
                                        react_1.default.createElement("path", { d: "M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })),
                                    react_1.default.createElement("label", { htmlFor: "file-upload", className: "relative p-2 cursor-pointer bg-white rounded-md font-medium text-primary-600 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500" },
                                        react_1.default.createElement("span", null, "Bilder hochladen"),
                                        react_1.default.createElement("input", { id: "file-upload", type: "file", name: "file", ref: input, multiple: true, accept: "image/*", onChange: onChangeHandler, className: "sr-only" }))),
                                react_1.default.createElement("div", { className: "flex flex-col" },
                                    files.length > 0 ? (react_1.default.createElement("span", { className: "text-gray-500 text-xs" },
                                        files.length,
                                        " ausgew\u00E4hlt")) : null,
                                    react_1.default.createElement("span", { className: "text-primary-600 hover:text-primary-500 font-medium cursor-pointer", onClick: handleClearFileUpload }, "Auswahl l\u00F6schen")))),
                        react_1.default.createElement("div", { className: "grid grid-cols-1 gap-2 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2" }, files
                            .sort((a, b) => (a.name > b.name) ? 1 : -1)
                            .map(file => (react_1.default.createElement("div", { key: file.name, className: "bg-white overflow-hidden shadow rounded-lg cursor-pointer" },
                            react_1.default.createElement("div", { className: "px-2 py-2" },
                                react_1.default.createElement("div", { className: "h-32 overflow-hidden mb-2" },
                                    react_1.default.createElement("img", { className: "object-contain h-full w-full", src: file.dataURL, onClick: () => { setSelectedFile(file); } })),
                                react_1.default.createElement("div", { className: "text-gray-500 text-xs text-center" }, file.name))))))))),
            react_1.default.createElement("div", { className: "col-span-4" },
                react_1.default.createElement("div", { className: "bg-white overflow-hidden shadow rounded-lg mb-4" },
                    react_1.default.createElement("div", { className: "px-4 py-5 sm:p-6" },
                        react_1.default.createElement("div", { className: "mb-2 flex items-start" },
                            react_1.default.createElement("div", { className: "flex-1 mr-4" },
                                react_1.default.createElement("div", { className: "mb-4" },
                                    react_1.default.createElement("label", { htmlFor: "first_name", className: "block text-sm font-medium text-gray-700" }, "Pflanzen"),
                                    react_1.default.createElement(async_1.default, { cacheOptions: true, onBlurResetsInput: false, placeholder: 'Suche...', isClearable: true, loadOptions: debouncedSearch, menuPortalTarget: document.body, onChange: handleSelectChange, getOptionValue: (option) => option.id, getOptionLabel: formatLabel })),
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement("label", { htmlFor: "authors", className: "block text-sm font-medium text-gray-700" }, "Autor"),
                                    react_1.default.createElement("select", { name: "authors", id: "authors", defaultValue: "", className: "mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm rounded-md", onChange: (event => setSelectedAuthor(event.target.value)) },
                                        react_1.default.createElement("option", { value: "" }, " "),
                                        authors.map(author => (react_1.default.createElement("option", { key: author.id, value: author.id },
                                            author.name,
                                            "\u00A0(",
                                            author.initials,
                                            ")")))))),
                            react_1.default.createElement(Button_1.default, { onClick: handleAssignImage, className: "mt-5", disabled: submitting }, "Zuordnen")))),
                react_1.default.createElement("div", { className: "bg-white overflow-hidden shadow rounded-lg" },
                    react_1.default.createElement("div", { className: "p-6" }, 
                    // @ts-ignore
                    selectedFile ? (react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: 'flex justify-between mb-2' },
                            react_1.default.createElement("button", { className: 'w-6', onClick: () => handleRotation('left') },
                                react_1.default.createElement(react_svg_1.ReactSVG, { src: '/images/rotate-left.svg' })),
                            react_1.default.createElement("button", { className: 'w-6', onClick: () => handleRotation('right') },
                                react_1.default.createElement(react_svg_1.ReactSVG, { src: '/images/rotate-right.svg' }))),
                        react_1.default.createElement("div", { className: 'overflow-hidden' },
                            react_1.default.createElement("img", { src: selectedFile.dataURL, alt: "", style: { transform: `rotate(${rotation}deg)` }, className: "w-full object-cover" })))) : (react_1.default.createElement("div", { className: "flex justify-center items-center p-20" },
                        react_1.default.createElement("span", { className: "text-gray-400 text-xl" }, "Kein Bild ausgew\u00E4hlt")))))),
            react_1.default.createElement("div", { className: "col-span-3" },
                react_1.default.createElement(ImageList_1.default, { images: plantImages, selectedRecord: selectedRecord, ref: imageListRef })))));
};
exports.default = Images;
